import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import * as Modals from 'fw/globals/Modals';
import { CheckBox } from 'fw/forms';
import { DownloadFileLink, Button } from "fw/components";
import * as Notifications from 'fw/globals/Notifications';

class BusinessStaff extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            businessStaff: props.businessStaff,
            majorityOwner: props.majorityOwner
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            businessStaff: nextProps.businessStaff
        });
    }

    onBusinessStaffEdit = (index) => {
        this.props.onEdit(index);
    }

    onNotApplicableChange = (value, index) => {
        const me = this;
        const businessStaff = this.state.businessStaff;
        let item = businessStaff[index];

        item.notApplicable = value;

        if(value) {
            if (!item.doneByMajorityOwner && item.lastName != null && item.lastName !== "" )
                Modals.confirm("By setting this Business Function as 'Not Applicable' you will remove the information for this Staff Member in case he/she is not the Majority Owner.<br /><br />"
                    + "If you wish to keep this Staff Member association, please select 'No' and you will be returned to the previous screen. If you wish to Discard this association, select 'Yes'.",
                    function () {
                        item.firstName = "";
                        item.lastName = "";
                        item.title = "";
                        item.email = "";
                        item.phones = [];
                        item.resumeFileName = null;
                        item.resumeStorageToken = null;
                        item.doneByMajorityOwner = false;
                        item.doNotSolicit = false;
                        me.setState({ businessStaff: businessStaff });
                    },
                    function () { 
                        item.notApplicable = false; 
                        me.setState({ businessStaff: businessStaff });
                    }
                );
            else {
                item.firstName = "";
                item.lastName = "";
                item.title = "";
                item.email = "";
                item.phones = [];
                item.resumeFileName = null;
                item.resumeStorageToken = null;
                item.doneByMajorityOwner = false;
                item.doNotSolicit = false;
            }
        }

        this.setState({ businessStaff: businessStaff })
        this.props.onChange(businessStaff);
    }

    onDoneByMajorityOwnerChange = (value, index) => {
        const me = this;
        const majorityOwner = this.state.majorityOwner;
        const businessStaff = this.state.businessStaff;
        let item = businessStaff[index];

        if(value && (majorityOwner.lastName === null || majorityOwner.lastName === "" )) {
            Modals.alert("There is no Majority Veteran Owner set. Please go to Veterans tab to set that information first.")
            item.doneByMajorityOwner = false;
            me.setState({ businessStaff: businessStaff });
            return;
        }

        item.doneByMajorityOwner = value;

        if(value) {
            if (item.lastName != null && item.lastName !== "" ){
                Modals.confirm("By setting this Business Function as 'Done by Majority Owner' you will remove the already assigned Staff Member.<br /><br />"
                    + "If you wish to keep this Staff Member association, please select 'No' and you will be returned to the previous screen. If you wish to Discard this association, select 'Yes'.",
                    function () {
                        businessStaff[index].firstName = majorityOwner.firstName;
                        item.lastName = majorityOwner.lastName;
                        item.title = majorityOwner.title;
                        item.email = majorityOwner.email;
                        item.phones = majorityOwner.phones;
                        item.resumeFileName = majorityOwner.resumeFileName;
                        item.resumeStorageToken = majorityOwner.resumeStorageToken;
                        me.setState({ businessStaff: businessStaff });
                    },
                    function () { 
                        item.doneByMajorityOwner = false;
                        me.setState({ businessStaff: businessStaff });
                    }
                );
            }
            else {
                item.firstName = majorityOwner.firstName;
                item.lastName = majorityOwner.lastName;
                item.title = majorityOwner.title;
                item.email = majorityOwner.email;
                item.phones = majorityOwner.phones;
                item.resumeFileName = majorityOwner.resumeFileName;
                item.resumeStorageToken = majorityOwner.resumeStorageToken;
                me.setState({ businessStaff: businessStaff });
            }
        }
        else {
            item.firstName = "";
            item.lastName = "";
            item.title = "";
            item.email = "";
            item.phones = [];
            item.resumeFileName = null;
            item.resumeStorageToken = null;
            item.doneByMajorityOwner = false;
            item.doNotSolicit = false;
        }

        this.setState({ businessStaff: businessStaff })
        this.props.onChange(businessStaff);
    }

    onDoNotContactChange = (value, index) => {
        const businessStaff = this.state.businessStaff;
        const staff = businessStaff[index];
        businessStaff[index].doNotSolicit = value;

        if (!value 
            && !staff.doneByMajorityOwner && staff.lastName != null && staff.lastName !== "" 
            && (staff.email === "" || staff.email === null || staff.phones[0] === null || staff.phones[0].number === "" || staff.phones[0].number === null))
        {
            Notifications.error('In order to uncheck "Do not contact", fields Email & Phone need to be completed. Please edit the selected Staff to complete these fields and uncheck this option.');
            businessStaff[index].doNotSolicit = !value;
        }

        this.setState({ businessStaff: businessStaff })
        this.props.onChange(businessStaff);
    }

    render() {
        let me = this;
        let rows = this.state.businessStaff !== undefined && this.state.businessStaff.map(function (item, index) {

            return (
                <tr key={index}>
                    <td>
                        {item.functionName}
                    </td>
                    <td>
                        <CheckBox name="doneByMajorityOwner" disabled={item.notApplicable} value={item.doneByMajorityOwner} style={{ marginTop: "-4px" }} onChange={(v) => me.onDoneByMajorityOwnerChange(v, index)} />
                    </td>
                    <td>
                        <CheckBox name="notApplicable" value={item.notApplicable} style={{ marginTop: "-4px" }} onChange={(v) => me.onNotApplicableChange(v, index)} />
                    </td>
                    <td>
                        {item.firstName}
                    </td>
                    <td>
                        {item.lastName}
                    </td>
                    <td>
                        {item.title}
                    </td>
                    <td>
                        {item.email}
                    </td>
                    <td>
                        {item.phones != null && item.phones.length > 0 ? item.phones[0].number : ""}
                    </td>
                    <td>
                        <DownloadFileLink
                            storageToken={item.resumeStorageToken}
                            fileName={item.resumeFileName}
                            buttonName={item.resumeFileName}
                            buttonStyle="link"
                            wrapFileNameLength={20}
                        />
                    </td>
                    <td>
                        <CheckBox name="doNotContact" disabled={item.notApplicable} value={item.doNotSolicit} style={{ marginTop: "-4px" }} onChange={(v) => me.onDoNotContactChange(v, index)} />
                    </td>
                    <td>
                        {!item.notApplicable && !item.doneByMajorityOwner &&
							<Button type="button" bsStyle="link" onClick={() => me.onBusinessStaffEdit(index)}>
                                <FontAwesomeIcon icon={faEdit} size="lg" color="black" />
							</Button>
                        }
                    </td>
                </tr>
            );
        });

        return (
            <div style={{ marginTop: "10px" }}>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>Function</th>
                            <th>Done by<br />Majority Owner</th>
                            <th>N/A</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Title</th>
                            <th>Email</th>
                            <th>Phone #</th>
                            <th>Resume</th>
                            <th>Please do not<br />contact</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default BusinessStaff;



// WEBPACK FOOTER //
// ./src/areas/certification/steps/businessStructure/businessStaff.js